(() => {

const $7f0ea56b1e5d28f3$var$WPGenForms = {
    init: function() {
        this.loadPluginOptions();
        this.eventListeners();
        this.updateSubmenuLinks();
    },
    loadPluginOptions: function() {
        var availablePlugins = wpgen_forms?.available_plugins || [];
        var availableServiceProviders = wpgen_forms?.available_service_providers || [];
        let pluginOptions = "";
        pluginOptions += `<option value="">Select a Plugin</option>`;
        availablePlugins.forEach((plugin)=>{
            pluginOptions += `<option value="${plugin.value}">${plugin.label}</option>`;
        });
        let serviceProviderOptions = "";
        serviceProviderOptions += `<option value="">Select a Service Provider</option>`;
        console.log("availableServiceProviders : ", availableServiceProviders);
        availableServiceProviders.forEach((serviceProvider)=>{
            let isDisabled = !serviceProvider.is_active ? "disabled" : "";
            console.log("isDisabled : ", isDisabled);
            serviceProviderOptions += '<option value="' + serviceProvider.value + '" ' + isDisabled + ">" + serviceProvider.label + "</option>";
        });
        jQuery("#wpgen-forms__form-plugin").html(pluginOptions);
        jQuery("#wpgen-forms__form-service-provider").html(serviceProviderOptions);
    },
    eventListeners: function() {
        jQuery("#wpgen-forms__generative-action").on("click", function() {
            console.log("\uD83E\uDD16 WordPress Generative Forms: Button Clicked!");
            jQuery(this).attr("disabled", false).text("Generate Form");
            let formName = jQuery("#wpgen-forms__form-name").val();
            let pluginType = jQuery("#wpgen-forms__form-plugin").val();
            let serviceProvider = jQuery("#wpgen-forms__form-service-provider").val();
            console.log("formName : ", formName);
            console.log("pluginType : ", pluginType);
            if (!formName || !pluginType || !serviceProvider) {
                alert("Please fill out the form name and select a plugin!");
                return;
            }
            let $currentElement = jQuery(this);
            jQuery($currentElement).attr("disabled", true).text("Generating Form...");
            // make ajax request
            jQuery.ajax({
                url: wpgen_forms.ajax_url,
                type: "POST",
                data: {
                    action: "wpgen_forms_generate_form",
                    nonce: wpgen_forms.wpgen_forms_generate_form_nonce,
                    form_name: formName,
                    plugin_type: pluginType,
                    service_provider: serviceProvider
                },
                success: function(response) {
                    console.log("\uD83E\uDD16 WPGenerative Forms: Response");
                    console.log(response);
                    if (response.status == "success") {
                        alert(response.message);
                        window.location.href = response.redirect_url;
                    } else {
                        alert("Form Generation Failed!. Please try again.");
                        jQuery($currentElement).removeAttr("disabled").text("Generate Form");
                    }
                },
                error: function(error) {
                    console.log("\uD83E\uDD16 WPGenerative Forms: Form Generation Failed!");
                    console.log(error);
                    alert("Form Generation Failed!. Please check the console for more details. And please report the issue to the plugin author.");
                }
            });
        });
        jQuery(".wpgen-forms__notice-action").on("click", function() {
            console.log(" wpgen-forms__notice-action clicked! ");
            const noticeActionType = jQuery(this).attr("data-action-type");
            console.log("noticeActionType : ", noticeActionType);
            jQuery.ajax({
                url: wpgen_forms.ajax_url,
                type: "POST",
                data: {
                    action: "wpgen_forms_update_feedback_notice_action",
                    nonce: wpgen_forms.nonce,
                    notice_action_type: noticeActionType
                },
                success: function(response) {
                    if ("success" == response?.status) window.location.reload();
                }
            });
        });
    },
    updateSubmenuLinks: function() {
        jQuery("#toplevel_page_wpgen-forms").find("ul li").each(function() {
            var $this = jQuery(this);
            var link = $this.find("a").attr("href");
            console.log("link : ", link);
            if (link === "wpgen-forms-support-forum") $this.find("a").attr("href", wpgen_forms.support_forum_url).attr("target", "_blank");
        });
    }
};
jQuery(function() {
    console.log("\uD83E\uDD16 WordPress Generative Forms: Main JS Ready! ");
    $7f0ea56b1e5d28f3$var$WPGenForms.init();
});

})();
//# sourceMappingURL=main.js.map
